"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericVideoEmbed = void 0;
const react_1 = __importDefault(require("react"));
const url_parse_1 = __importDefault(require("url-parse"));
const isVimeo = (embedSrc) => {
    if (embedSrc.indexOf('.vimeo.com') > -1) {
        return true;
    }
    return false;
};
const enforceDoNotTrack = (embedSrc) => {
    if (embedSrc && isVimeo(embedSrc)) {
        const parsedUrl = (0, url_parse_1.default)(embedSrc, true);
        //https://developer.vimeo.com/player/sdk/embed
        parsedUrl.query.dnt = 'true';
        return parsedUrl.toString();
    }
    return embedSrc;
};
const GenericVideoEmbed = (props) => {
    const { embedSrc, height, width, title } = props;
    if (!embedSrc)
        return react_1.default.createElement("div", null);
    const src = enforceDoNotTrack(embedSrc);
    return (react_1.default.createElement("div", { className: "gen-video-embed embed-responsive embed-responsive-16by9" },
        react_1.default.createElement("span", { className: "gen-video embed-responsive-item" },
            react_1.default.createElement("iframe", { frameBorder: 0, allow: "autoplay; fullscreen", allowFullScreen: true, title: title || 'Epic Video Embed', src: src, height: height, width: width }))));
};
exports.GenericVideoEmbed = GenericVideoEmbed;
//# sourceMappingURL=GenericVideoEmbed.js.map